module.exports = __webpack_public_path__ + "img/topic.f59c4851.svg";